import type { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';
import HomePage from '../pages/home/page';
import ArticlePage from '../pages/article/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/en',
    element: <HomePage />,
  },
  {
    path: '/fr',
    element: <HomePage />,
  },
  {
    path: '/de',
    element: <HomePage />,
  },
  {
    path: '/da',
    element: <HomePage />,
  },
  {
    path: '/en/article/:slug',
    element: <ArticlePage />,
  },
  {
    path: '/fr/article/:slug',
    element: <ArticlePage />,
  },
  {
    path: '/de/article/:slug',
    element: <ArticlePage />,
  },
  {
    path: '/da/article/:slug',
    element: <ArticlePage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;